import { parse } from "tldts";

export const getUrlData = () => {
  const subdomain = parse(window.location.origin).subdomain;
  let url = "";
  let appType = "codems";
  switch (subdomain) {
    case "kadunaems":
      appType = "codems";
      url = "https://kqwe.kssqaa.org/vs";
      break;
    default:
      appType = "codems";
      url = "https://emsdemo.kssqaa.org/vs";
      break;
  }
  return { url, subdomain, appType };
};
